<template>
    <div id="app">
        <div class="hidden sm:block text-white text-center bg-azuloscuro z-50 p-6 text-sm" v-if="!mobileOnlyMessageDismissed">
            SkillPills es una WebApp optimizada y orientada para dispositivos móviles
            <button class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-full mx-3 mt-2 text-sm" @click="mobileOnlyMessageDismissed = true">Lo entiendo y quiero continuar</button>
        </div>
      <router-view class="view"></router-view>

    </div>
</template>

<script>
    const App = {
        name: "App",
        data () {
          return {
              mobileOnlyMessageDismissed: false
          }
        },
        computed: {
            layout(){
                return this.$route.matched[0].components.default.layout || ''
            }
        }
    }

    export default App
</script>

<style scoped>

</style>
